import { useMediaQuery } from '@mui/system';
import { useTheme } from 'styled-components';

function useIsMobile() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
}

export default useIsMobile;
